export default __webpack_public_path__ + "static/media/app_maintenance.e14db145.svg";